import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemsListComponent } from './items-list.component';
import { UtilitiesModule } from '../../utilities/utilities.module';
import { ItemsListHeadItemComponent } from './head-item/head-item.component';
import { ItemsListContentComponent } from './list-content/list-content.component';
import { ItemsListContentListViewComponent } from './list-content/content-list-view/content-list-view.component';
import { ItemsListContentGridViewComponent } from './list-content/content-grid-view/content-grid-view.component';
import { ItemsListRowComponent } from './list-row/list-row.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { ItemsListRowItemComponent } from './list-row/list-row-item/list-row-item.component';
import { ItemsListRowItemAComponent } from './list-row/list-row-item/a/a.component';
import { ItemsListRowItemIconAComponent } from './list-row/list-row-item/icon-a/icon-a.component';
import { ItemsListRowItemDisplayValueComponent } from './list-row/list-row-item/display-value/display-value.component';
import { ItemsListRowItemArrayAComponent } from './list-row/list-row-item/array-a/array-a.component';
import { ItemsListRowItemImageIconAComponent } from './list-row/list-row-item/image-icon-a/image-icon-a.component';
import { ItemsListRowItemEmailComponent } from './list-row/list-row-item/email/email.component';
import { ItemsListRowItemTelComponent } from './list-row/list-row-item/tel/tel.component';
import { ItemsListContentListViewWithChildrenComponent } from './list-content/content-list-view-with-children/content-list-view-with-children.component';
import { ItemsListContentGridViewWithChildrenComponent } from './list-content/content-grid-view-with-children/content-grid-view-with-children.component';
import { ItemsListRowItemArraySpanComponent } from './list-row/list-row-item/array-span/array-span.component';
import { ItemsListContentListViewWithChildrenRowSetComponent } from './list-content/content-list-view-with-children-row-set/content-list-view-with-children-row-set.component';
import { ItemsListRowItemImageIconComponent } from './list-row/list-row-item/image-icon/image-icon.component';
import { ItemsListRowItemTagsComponent } from './list-row/list-row-item/tags/tags.component';
import { ItemsListRowItemDateTimeComponent } from './list-row/list-row-item/date-time/date-time.component';
import { ItemsListHeadItemLabelComponent } from './head-item/head-item-label/head-item-label.component';
import { ItemsListRowItemActionsComponent } from './list-row/list-row-item/actions/actions.component';
import { FiItemsListNameClickDirective } from './list-name-click/list-name-click.directive';
import { FiItemsListMoreMenuMobileComponent } from './more-menu-mobile/more-menu-mobile.component';
import { FiItemsListDisplayTypeSelectComponent } from './list-display-type-select/list-display-type-select.component';
import { ItemsListRowItemSpanPlainComponent } from '@fi-app/components/items-list/list-row/list-row-item/span/span-plain.component';
import { ItemsListRowItemSpanChildAComponent } from '@fi-app/components/items-list/list-row/list-row-item/span/span-child-a.component';
import { FiItemsListTranscludeDirective } from '@fi-app/components/items-list/items-list-transclude.directive';
import { ItemsListActionsComponent } from './items-list-actions/items-list-actions.component';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        MatCheckboxModule,
        FormsModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        FiEmptyListModule,
        FiItemsListModule,
        FiLocalSearch2Module,
    ],
    declarations: [
        ItemsListComponent,
        ItemsListHeadItemComponent,
        ItemsListContentComponent,
        ItemsListContentListViewComponent,
        ItemsListContentListViewWithChildrenComponent,
        ItemsListContentGridViewComponent,
        ItemsListContentGridViewWithChildrenComponent,
        ItemsListRowComponent,
        ItemsListRowItemComponent,
        ItemsListRowItemDisplayValueComponent,
        ItemsListRowItemSpanPlainComponent,
        ItemsListRowItemSpanChildAComponent,
        ItemsListRowItemAComponent,
        ItemsListRowItemIconAComponent,
        ItemsListRowItemArrayAComponent,
        ItemsListRowItemImageIconAComponent,
        ItemsListRowItemEmailComponent,
        ItemsListRowItemTelComponent,
        ItemsListRowItemArraySpanComponent,
        ItemsListRowItemImageIconComponent,
        ItemsListContentListViewWithChildrenRowSetComponent,
        ItemsListRowItemTagsComponent,
        ItemsListRowItemDateTimeComponent,
        ItemsListHeadItemLabelComponent,
        ItemsListRowItemActionsComponent,
        FiItemsListNameClickDirective,
        FiItemsListMoreMenuMobileComponent,
        FiItemsListDisplayTypeSelectComponent,
        FiItemsListTranscludeDirective,
        ItemsListActionsComponent,
    ],
    exports: [
        ItemsListComponent,
        ItemsListRowComponent,
        FiItemsListMoreMenuMobileComponent,
        FiItemsListDisplayTypeSelectComponent,
        FiItemsListTranscludeDirective,
        ItemsListActionsComponent,
    ],
})
export class ItemsListModule {}
